import applyCaseMiddleware from 'axios-case-converter';
import axios from 'axios';

export const apiBaseQuery = async ({
  bypassCaseConverter = false,
  headers,
  token,
  body: data,
  ...rest
}) => {
  const client = bypassCaseConverter
    ? axios.create()
    : applyCaseMiddleware(axios.create());

  const authorizedHeaders = {
    ...(!!token && { Authorization: `Bearer ${token}` }),
    ...headers,
  };

  try {
    const result = await client.request({
      ...rest,
      data,
      headers : authorizedHeaders,
    });
    return { data: result.data };
  } catch (axiosError) {
    return {
      error : {
        status : axiosError.response?.status,
        data   : axiosError.response?.data || axiosError.message,
      },
    };
  }
};
